import { Injectable } from '@angular/core';
import { IdentityApiModel } from './api/v2/Models/IdentityApiModel';
import { SpaEventService } from './spaEvents.service';
import { ResourceIdentityApiModel } from './api/v2/Models/ResourceIdentityApiModel';
import { AuthService, ReadonlyUser } from '@public/src/application/services/auth/mod';
import { sharedResolution } from '../../../src/shared_resolution';

@Injectable()
export class AuthContextService {
	public patientIdentity: IdentityApiModel | null = null;
	public resourceIdentity: ResourceIdentityApiModel | null = null;
	public isAuthenticatedOutsider = false;

	constructor(private spaEventService: SpaEventService) {}

	public signInPatient(ctx: { legacySignin: Boolean } | null = null, emit = true): void {
		const authService = sharedResolution.resolve(AuthService);
		const user = authService.getUser();
		if (user == null) {
			this.patientIdentity = null;
		} else {
			if ((user.userType as any) === 'Resource') {
				this.patientIdentity = null;

				return;
			}
			const identity = new IdentityApiModel();

			if (ctx?.legacySignin) {
				identity.legacyDocumentSignin = true;
			}

			identity.Id = user.id;
			identity.Nationality = user.nationality;
			identity.NationalIdentityNumber = user.nationalIdentityNumber;
			identity.Phone = user.phone;
			identity.FirstName = user.firstName;
			identity.LastName = user.lastName;
			identity.Email = user.email;
			identity.NationalIdentityNumberRequirement = user.nationalIdentityNumberRequirement;
			identity.PhoneRequirement = user.phoneRequirement;
			identity.EmailRequirement = user.emailRequirement;
			identity.UserType = user.userType;
			this.patientIdentity = identity;

			this.spaEventService.onSigningIn.emit();

			if (!emit) return;

			if (this.patientIdentity.UserType === 'Client') {
				this.spaEventService.onSignedIn.emit(this.patientIdentity);
			} else {
				this.spaEventService.onSignedInAsOutsider.emit(true);
			}
		}
	}

	public isPatient(): boolean {
		return this.patientIdentity !== null;
	}

	public isOutsider(): boolean {
		return this.patientIdentity !== null && this.patientIdentity.UserType === 'Outsider';
	}

	public isClient(): boolean {
		return this.patientIdentity !== null && this.patientIdentity.UserType === 'Client';
	}

	public isResource(): boolean {
		return this.resourceIdentity !== null;
	}

	public needsLegacyDocumentSigning(): boolean {
		return this.patientIdentity !== null && this.patientIdentity.legacyDocumentSignin;
	}

	public isSignedIn(): boolean {
		return this.isPatient() || this.isResource();
	}
}
